import { Ebbne, MountWithEbbne } from "@solidwhite/ebbnen";
import Section from "../../Section";
import SubSection from "../../SubSection";
import PowerrailApplications from "./powerrail/PowerrailApplications";
import PowerFloorApplication from "./PowerfloorApplication";
import StaticChargeApplication from "./StaticChargeApplication";
import DynamicChargeApplication from "./DynamicChargeApplication";

const ChargeApplications = ({ nodes }) => {
  return (
    <Ebbne id="c-applications">
      <group position={nodes.applications.position} rotation={nodes.applications.rotation}>
        <Section object3d={nodes.applications} />

        <Ebbne id="powerrail" visibleWithAbove={2}>
          <SubSection object3d={nodes.powerrail} hideWhenActive />

          <MountWithEbbne>
            <group position={nodes.powerrail.position}>
              <PowerrailApplications />
            </group>
          </MountWithEbbne>
        </Ebbne>

        <Ebbne id="dynamic" visibleWithAbove={2}>
          <SubSection object3d={nodes.dynamic}>
            <MountWithEbbne>
              <DynamicChargeApplication object3d={nodes.dynamic} />
            </MountWithEbbne>
          </SubSection>
        </Ebbne>

        <Ebbne id="powerfloor" visibleWithAbove={2}>
          <SubSection object3d={nodes.powerfloor}>
            <MountWithEbbne>
              <PowerFloorApplication object3d={nodes.powerfloor} />
            </MountWithEbbne>
          </SubSection>
        </Ebbne>

        <Ebbne id="static" visibleWithAbove={2}>
          <SubSection object3d={nodes.static}>
            <MountWithEbbne>
              <StaticChargeApplication object3d={nodes.static} />
            </MountWithEbbne>
          </SubSection>
        </Ebbne>
      </group>
    </Ebbne>
  );
};

export default ChargeApplications;
